var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.75 10H14V4.25A1.25 1.25 0 0 0 12.75 3h-1.5A1.25 1.25 0 0 0 10 4.25V10H4.25A1.25 1.25 0 0 0 3 11.25v1.5A1.25 1.25 0 0 0 4.25 14H10v5.75A1.25 1.25 0 0 0 11.25 21h1.5A1.25 1.25 0 0 0 14 19.75V14h5.75A1.25 1.25 0 0 0 21 12.75v-1.5A1.25 1.25 0 0 0 19.75 10Z"
})));
export default SvgPlus;